export const formatCurrency = (amount, options) =>
  new Intl.NumberFormat("es-MX", {
    ...options,
    style: "currency",
    currency: "MXN",
  }).format(amount);

  //maximumFractionDigits: 2,